import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { Modal } from 'react-bootstrap';
import _ from 'lodash';

import './index.scss';
import 'bootstrap/dist/css/bootstrap.min.css';

import TemplateBotForm from './Components/TemplateBotForm';

const TemplateBotModal = (props) => {
  const {
    show,
    bot,
    items,
    connectors,
    setShow,
    templateBotData,
    templateBotId,
  } = props;

  const onHideModal = () => {
    setShow(false);
  };

  const renderModalTitle = () => {
    const text = !_.isEmpty(templateBotData) ? 'Editar' : 'Exportar como';
    return `${text} template`;
  };

  return (
    <Modal show={show} onHide={onHideModal}>
      <Modal.Header className="template-bot-modal-header-title" closeButton>
        <Modal.Title>{renderModalTitle()}</Modal.Title>
      </Modal.Header>
      <TemplateBotForm
        bot={bot}
        items={items}
        connectors={connectors}
        setShow={setShow}
        templateBotId={templateBotId}
      />
    </Modal>
  );
};

const mapStateToProps = (state) => {
  return {
    templateBotData: state.templateBot.templateBotData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({}, dispatch);
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(TemplateBotModal)
);
